<!-- 8. CONTÁCTAME -->
<div class="contact-section" id="contacto">
  <!-- Encabezado: mismo patrón que servicios (título + párrafo centrados) -->
  <header class="contact-head">
    <h2 class="section-title2" appRevealOnScroll>Contáctanos</h2>
    <p class="contact-lead">
      ¿Quieres una consulta? Déjanos tus datos y envíanos tu mensaje por WhatsApp,
      o escríbenos por el canal que prefieras.
    </p>
  </header>

  <div class="contact-container">
    <div class="contact-info">
      <div class="contact-methods">
        <div class="contact-method" *ngFor="let method of contactMethods">
          <span class="contact-method-icon" aria-hidden="true">
            <i [class]="method.icon"></i>
          </span>
          <div>
            <h4>{{ method.title }}</h4>
            <p>
              <a *ngIf="method.href; else plainValue" [href]="method.href">{{ method.value }}</a>
              <ng-template #plainValue>{{ method.value }}</ng-template>
            </p>
          </div>
        </div>
      </div>

      <div class="social-links">
        <a [href]="social.url" target="_blank" rel="noopener" class="social-link" *ngFor="let social of socialLinks"
           [attr.aria-label]="social.label">
          <i [class]="social.icon" aria-hidden="true"></i>
        </a>
      </div>
    </div>

    <div class="contact-form">
      <form (ngSubmit)="enviarWhatsApp()">
        <label class="form-group">
          <input type="text" [(ngModel)]="form.name" name="name" placeholder="Tu nombre" aria-label="Tu nombre" required>
        </label>

        <label class="form-group">
          <input type="email" [(ngModel)]="form.email" name="email" placeholder="Tu email" aria-label="Tu email" required>
        </label>

        <label class="form-group">
          <input type="text" [(ngModel)]="form.subject" name="subject" placeholder="Asunto" aria-label="Asunto" required>
        </label>

        <label class="form-group">
          <textarea [(ngModel)]="form.message" name="message" placeholder="Tu mensaje" aria-label="Tu mensaje" rows="5" required></textarea>
        </label>

        <button type="submit" class="btn-submit">
          <i class="fas fa-paper-plane"></i>
          Enviar Mensaje
        </button>
      </form>
    </div>
  </div>
</div>
